module.exports = __webpack_public_path__ + "static/FOOTERBACKGROUND-10-cf7af786adbf7d12fc4e42f1d1388c5c.jpg";